import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useState, useCallback } from 'react'
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Cropper from 'react-easy-crop'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


const AddFoodDialog = ({ addMeal, userId, uploadImage }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setMealTitle('');
    setIngredients([]);
    setIngredientsInputs([{ inputNumber: 0, amount: 0, ingredientUnit: "-" }])
    setPortions(2);
    setOpen(false);
  };


  const [mealTitle, setMealTitle] = useState('')
  const [ingredients, setIngredients] = useState([])
  const [ingredientsInputs, setIngredientsInputs] = useState([{ inputNumber: 0 }])
  const [portions, setPortions] = useState(2);
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);


  const onImageChange = (event) => {
    setImage(event.target.files[0]);
  };

  const onImageUpload = () => {

    // Create an object of formData
    const formData = new FormData();

    // Update the formData object
    formData.append(
      "mealimage",
      image,
      mealTitle + "-image.jpg"
    );

    // Details of the uploaded file
    console.log(image);

    // Request made to the backend api
    // Send formData object
    // axios.post("api/uploadfile", formData);
    uploadImage(formData);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    //onAddFood({mealTitle, ingredients});

  }

  const setIngredient = (inputNumber, ingredientText) => {
    if (ingredients.find(({ id }) => id === inputNumber) !== undefined) {
      setIngredients(ingredients.map((ingredient) => ingredient.id === inputNumber ? { ...ingredient, name: ingredientText } : ingredient))
    }
    else {
      const newIngredient = { id: inputNumber, name: ingredientText };
      setIngredients([...ingredients, newIngredient]);
    }
  }
  const setIngredientAmount = (inputNumber, ingredientAmount) => {
    if (ingredients.find(({ id }) => id === inputNumber) !== undefined) {
      setIngredients(ingredients.map((ingredient) => ingredient.id === inputNumber ? { ...ingredient, amount: ingredientAmount } : ingredient))
    }
    else {
      const newIngredient = { id: inputNumber, amount: ingredientAmount };
      setIngredients([...ingredients, newIngredient]);
    }
  }

  const setIngredientUnit = (inputNumber, ingredientUnit) => {
    if (ingredients.find(({ id }) => id === inputNumber) !== undefined) {
      setIngredients(ingredients.map((ingredient) => ingredient.id === inputNumber ? { ...ingredient, unit: ingredientUnit } : ingredient))
    }
    else {
      const newIngredient = { id: inputNumber, unit: ingredientUnit };
      setIngredients([...ingredients, newIngredient]);
    }
  }

  const addPortion = () => {
    setPortions(portions + 1);
  }

  const decreasePortion = () => {
    setPortions(portions - 1);
  }

  const appendInput = () => {
    const newInput = { inputNumber: ingredientsInputs.length };
    setIngredientsInputs([...ingredientsInputs, newInput])
  }

  const addNewMeal = () => {

    ingredients.forEach(function (ingredient) {
      if (ingredient.amount !== undefined && portions > 0) {
        ingredient.amount = ingredient.amount / portions;
      }
    })

    const newMeal = {
      id: 0,
      title: mealTitle,
      creatorId: userId,
      ingredients: [],
      description: description
    }
    ingredients.map((ingredient) => (newMeal.ingredients.push(ingredient)));

    addMeal(newMeal);
    onImageUpload();

    handleClose();
  }

  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    console.log(croppedArea, croppedAreaPixels)
  }, [])

  return (
    <div>
      <button className='btn btn-block' onClick={handleClickOpen}>
        New Meal
      </button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" className='dialog' open={open} maxWidth='xs' fullWidth>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add Meal
        </DialogTitle>
        <DialogContent dividers>
          <form className='add-form' onSubmit={onSubmit}>
            <div className='form-control'>
              <input type="file" onChange={(event) => onImageChange(event)} />
              {/* {image ??
                <Cropper
                  image={image}
                  crop={crop}
                  zoom={zoom}
                  aspect={4 / 3}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                />} */}

              <label>Meal Title</label>
              <input type='text' className="" placeholder='Meal Title' value={mealTitle} onChange={(e) => setMealTitle(e.target.value)}></input>
            </div>
            <div className='form-control'>
              <label>Ingredients</label>
              {ingredientsInputs.map((input) => (
                <div className="flex" key={input.inputNumber + "div1"}>
                  <div className="width60" key={input.inputNumber + "div2"}>
                    <input key={input.inputNumber} type='text' id={input} placeholder='ingredient' onChange={(e) => setIngredient(input.inputNumber, e.target.value)}></input>
                  </div>
                  <div className="width25" key={input.inputNumber + "div3"}>
                    <input key={input.inputNumber + "amount"} type='number' placeholder='amount' min="0" onChange={(e) => setIngredientAmount(input.inputNumber, e.target.value)}></input>
                  </div>
                  <div className="width15" key={input.inputNumber + "div4"}>
                    <select name="unit" key={input.inputNumber + "unit"} className="dropdown max-width" onChange={(e) => setIngredientUnit(input.inputNumber, e.target.value)}>
                      <option value="none">-</option>
                      <option value="gr">gr</option>
                      <option value="ml">ml</option>
                      <option value="kg">kg</option>
                      <option value="l">l</option>
                    </select>
                  </div>
                </div>
              ))}
              <IconButton className='.btn-block' onClick={() => appendInput()}>
                <AddCircleIcon></AddCircleIcon>
              </IconButton>
            </div>
            <div className="right">
              <label className="width60">Amounts apply for</label>
              <IconButton onClick={decreasePortion}>
                <RemoveCircleOutlineIcon></RemoveCircleOutlineIcon>
              </IconButton>
              <input className="width7" key="portions" type='number' value={portions} min="1" max="20" onChange={(e) => setPortions(e.target.value)}></input>
              <IconButton onClick={addPortion} className="icon-buttons">
                <AddCircleOutlineIcon></AddCircleOutlineIcon>
              </IconButton>
              <label className="width25">portion/s</label>
            </div>
            <textarea rows="10" className="max-width" placeholder="Description..." name="description" onChange={(e) => setDescription(e.target.value)}></textarea>
            <input type='submit' value='Save Meal' onClick={addNewMeal} className='btn btn-block'></input>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AddFoodDialog
